<template>
  <section class="sp">
    <div class="sp-blob sp-blob--1"></div>
    <div class="sp-blob sp-blob--2"></div>

    <div class="sp-card" :class="{ 'sp-card--wide': searched }">
      <div class="sp-header">
        <div class="sp-icon">
          <i class="pi pi-search"></i>
        </div>
        <h1 class="sp-title">الاستعلام عن الحجز</h1>
        <p class="sp-subtitle">أدخل رقم هاتف ولي الأمر للاستعلام عن حالة الحجز</p>
      </div>

      <form @submit.prevent="sendForm()" class="sp-form">
        <div class="sp-field" :class="{ 'sp-field--error': v$.parent_phone.$error }">
          <label class="sp-label" for="parentPhone">رقم هاتف ولي الأمر</label>
          <div class="sp-input-wrap">
            <i class="pi pi-phone sp-input-icon"></i>
            <InputText
              id="parentPhone"
              v-model="parent_phone"
              inputmode="tel"
              placeholder="أدخل رقم هاتف ولي الأمر"
              @keypress="onlyNumbers"
              class="sp-input"
            />
          </div>
          <span class="sp-error" v-if="v$.parent_phone.$error">
            <i class="pi pi-exclamation-circle"></i> برجاء إدخال رقم هاتف ولي الأمر
          </span>
        </div>

        <button type="submit" class="sp-btn" :disabled="formSending">
          <i class="pi pi-spin pi-spinner-dotted" v-if="formSending"></i>
          <i class="pi pi-search" v-else></i>
          {{ formSending ? 'جاري البحث...' : 'بحث' }}
        </button>
      </form>

      <div class="sp-results" v-if="searched">
        <div v-if="reservations.length" class="sp-table-wrap">
          <table class="sp-table">
            <thead>
              <tr>
                <th>رقم الحجز</th>
                <th>اسم الطالب</th>
                <th>حالة الحجز</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(reservation, index) in reservations" :key="index">
                <td data-label="رقم الحجز">{{ reservationNumberDisplay(reservation) }}</td>
                <td data-label="اسم الطالب">{{ reservation.name }}</td>
                <td data-label="حالة الحجز">
                  <span class="status-badge" :class="statusBadgeClass(reservation.status)">
                    {{ statusLabel(reservation.status) }}
                  </span>
                </td>
                <td data-label="">
                  <button type="button" class="sp-details-btn" @click="showDetails(reservation)">
                    عرض التفاصيل
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else class="sp-empty">
          اعذرًا، لا يوجد أي حجز مرتبط بهذا الرقم.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import InputText from 'primevue/inputtext';
import useVuelidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import axios from 'axios';
import Swal from 'sweetalert2';
import { websiteTexts } from '@/websiteTexts';

export default {
    name: "search-page",
    components: {
        InputText
    },
    data() {
        return {
            v$: useVuelidate(),
            parent_phone: null,
            formSending: false,
            searched: false,
            reservations: []
        }
    },
    validations() {
        return {
            parent_phone: { required },
        };
    },
    computed: {
        websiteTexts() {
            return websiteTexts;
        }
    },
    methods: {
        onlyNumbers(event) {
            const char = String.fromCharCode(event.which);
            if (!/[0-9٠-٩]/.test(char)) {
                event.preventDefault();
                return;
            }
            const value = event.target.value;
            const digitsCount = (value.match(/[0-9٠-٩]/g) || []).length;
            if (digitsCount >= 11) {
                event.preventDefault();
            }
        },
        statusLabel(status) {
            switch (status) {
                case 1: return 'مقبول';
                case 2: return 'مرفوض';
                case 3: return 'في انتظار الشهادة';
                default: return 'معلق';
            }
        },
        statusBadgeClass(status) {
            switch (status) {
                case 1: return 'status-badge--accepted';
                case 2: return 'status-badge--rejected';
                case 3: return 'status-badge--waiting';
                default: return 'status-badge--pending';
            }
        },
        reservationNumberDisplay(reservation) {
            if (reservation.status == 1) {
                return reservation.id;
            }
            if (reservation.status == 2) {
                return 'لا يوجد رقم حجز';
            }
            return 'سيظهر رقم الحجز بعد قبول الحجز';
        },
        showDetails(reservation) {
            if (reservation.status == 1) {
                Swal.fire({
                    position: "center",
                    icon: "success",
                    html: (reservation.accept_message || websiteTexts.data.confirm_text || '').replace(/&nbsp;/g, ' '),
                });
            } else if (reservation.status == 2) {
                Swal.fire({
                    position: "center",
                    icon: "error",
                    html: (reservation.reject_message || websiteTexts.data.reject_text || '').replace(/&nbsp;/g, ' '),
                });
            } else if (reservation.status == 3) {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    html: "<p class='text-center'>برجاء التواصل عبر الرقم <a href='https://wa.me/+201552315977' class='text-info' target='_blank'>01552315977</a> <br />  لارفاق صوره الشهاده المعتمده باسم الطالب ودرجته خلال 48 ساعه وذلك لعدم رفض الطالب</p>",
                });
            } else {
                Swal.fire({
                    position: "center",
                    icon: "warning",
                    html: (reservation.waiting_message || websiteTexts.data.wait_text || '').replace(/&nbsp;/g, ' '),
                });
            }
        },
        sendForm() {
            this.v$.$validate();
            if (!this.v$.$error) {
                const formData = new FormData();
                formData.append('parent_phone', this.parent_phone);
                this.formSending = true;

                axios
                    .post('/check_reservation', formData)
                    .then((response) => {
                        this.formSending = false;
                        this.reservations = response.data.data || [];
                        this.searched = true;
                    })
                    .catch((error) => {
                        this.formSending = false;
                        Swal.fire({
                            position: "center",
                            icon: "error",
                            title: error.response.data.message,
                        });
                    });
            }
        }
    }
}
</script>

<style scoped>
.sp {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  position: relative;
  overflow: hidden;
  background: linear-gradient(150deg, #0A0A0A 0%, #111111 100%);
}

.sp-blob {
  position: absolute;
  border-radius: 50%;
  filter: blur(70px);
  opacity: 0.18;
  pointer-events: none;
}

.sp-blob--1 {
  width: 420px;
  height: 420px;
  background: var(--primary, #D4AF37);
  top: -120px;
  right: -100px;
  animation: blob-drift 8s ease-in-out infinite alternate;
}

.sp-blob--2 {
  width: 320px;
  height: 320px;
  background: var(--accent, #C89B2D);
  bottom: -100px;
  left: -80px;
  animation: blob-drift 10s ease-in-out infinite alternate-reverse;
}

@keyframes blob-drift {
  from { transform: translate(0, 0) scale(1); }
  to   { transform: translate(20px, 15px) scale(1.06); }
}

.sp-card {
  background: #ffffff;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(212, 175, 55, 0.1), 0 4px 16px rgba(0,0,0,0.06);
  padding: 3rem 2.5rem;
  width: 100%;
  max-width: 440px;
  position: relative;
  z-index: 1;
  transition: max-width 0.2s;
}

.sp-card--wide {
  max-width: 720px;
}

/* ── Header ── */
.sp-header {
  text-align: center;
  margin-bottom: 2.5rem;
}

.sp-icon {
  width: 72px;
  height: 72px;
  background: linear-gradient(135deg, var(--primary, #D4AF37), var(--accent, #C89B2D));
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.25rem;
  box-shadow: 0 12px 32px rgba(212, 175, 55, 0.3);
}

.sp-icon i {
  font-size: 1.75rem;
  color: #fff;
}

.sp-title {
  font-size: 1.55rem;
  font-weight: 700;
  color: #1A1A1A;
  margin: 0 0 0.5rem;
  line-height: 1.3;
}

.sp-subtitle {
  font-size: 0.92rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.7;
}

/* ── Form ── */
.sp-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.sp-field {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
}

.sp-label {
  font-size: 0.88rem;
  font-weight: 600;
  color: #374151;
}

.sp-input-wrap {
  position: relative;
}

.sp-input-icon {
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--primary, #D4AF37);
  font-size: 1rem;
  pointer-events: none;
  z-index: 1;
}

.sp-input-wrap :deep(.p-inputtext) {
  width: 100%;
  padding: 0.85rem 2.75rem 0.85rem 1rem;
  border-radius: 12px;
  border: 1.5px solid #e5e7eb;
  font-family: inherit;
  font-size: 1rem;
  color: #1f2937;
  background: #fafafa;
  transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
  direction: ltr;
  text-align: right;
  letter-spacing: 0.03em;
}

.sp-input-wrap :deep(.p-inputtext::placeholder) {
  color: #9ca3af;
  direction: rtl;
}

.sp-input-wrap :deep(.p-inputtext:focus) {
  border-color: var(--primary, #D4AF37);
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.12);
  background: #fff;
  outline: none;
}

.sp-field--error .sp-input-wrap :deep(.p-inputtext) {
  border-color: #ef4444;
  background: #fff8f8;
}

.sp-field--error .sp-input-wrap :deep(.p-inputtext:focus) {
  box-shadow: 0 0 0 3px rgba(239, 68, 68, 0.1);
}

.sp-error {
  font-size: 0.8rem;
  color: #ef4444;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

/* ── Button ── */
.sp-btn {
  width: 100%;
  padding: 0.9rem 1.5rem;
  background: linear-gradient(135deg, var(--primary, #D4AF37), var(--accent, #C89B2D));
  color: #fff;
  border: none;
  border-radius: 12px;
  font-family: inherit;
  font-size: 1.05rem;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  box-shadow: 0 8px 24px rgba(212, 175, 55, 0.3);
  transition: opacity 0.2s, transform 0.15s, box-shadow 0.2s;
}

.sp-btn:hover:not(:disabled) {
  opacity: 0.92;
  transform: translateY(-2px);
  box-shadow: 0 12px 32px rgba(212, 175, 55, 0.35);
}

.sp-btn:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 6px 16px rgba(212, 175, 55, 0.25);
}

.sp-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ── Results ── */
.sp-results {
  margin-top: 2rem;
}

.sp-table-wrap {
  overflow-x: auto;
}

.sp-table {
  width: 100%;
  border-collapse: collapse;
}

.sp-table thead th {
  text-align: right;
  font-size: 0.82rem;
  font-weight: 700;
  color: #6b7280;
  padding: 0.6rem 0.75rem;
  border-bottom: 2px solid #f0f0f0;
}

.sp-table tbody td {
  padding: 0.85rem 0.75rem;
  font-size: 0.92rem;
  color: #1f2937;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
}

.sp-details-btn {
  border: 1.5px solid var(--primary, #D4AF37);
  background: transparent;
  color: var(--primary, #D4AF37);
  border-radius: 8px;
  padding: 0.4rem 0.9rem;
  font-size: 0.82rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.2s, color 0.2s;
}

.sp-details-btn:hover {
  background: var(--primary, #D4AF37);
  color: #fff;
}

.sp-empty {
  text-align: center;
  padding: 1.5rem 1rem;
  color: #6b7280;
  font-size: 0.95rem;
  background: #fafafa;
  border-radius: 12px;
}

/* status badges */
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3125rem;
  padding: 0.25rem 0.6875rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 700;
  white-space: nowrap;
}

.status-badge::before {
  content: '';
  width: 5px;
  height: 5px;
  border-radius: 50%;
}

.status-badge--pending {
  background: rgba(245, 158, 11, 0.12);
  color: #b45309;
}
.status-badge--pending::before { background: #f59e0b; }

.status-badge--accepted {
  background: rgba(16, 185, 129, 0.12);
  color: #047857;
}
.status-badge--accepted::before { background: #10b981; }

.status-badge--rejected {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
}
.status-badge--rejected::before { background: #ef4444; }

.status-badge--waiting {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
}
.status-badge--waiting::before { background: #3b82f6; }

/* ── Responsive ── */
@media (max-width: 480px) {
  .sp-card {
    padding: 2rem 1.5rem;
    border-radius: 20px;
  }

  .sp-title {
    font-size: 1.3rem;
  }

  .sp-icon {
    width: 60px;
    height: 60px;
  }

  .sp-icon i {
    font-size: 1.4rem;
  }
}

@media (max-width: 640px) {
  .sp-table thead {
    display: none;
  }

  .sp-table, .sp-table tbody, .sp-table tr, .sp-table td {
    display: block;
    width: 100%;
  }

  .sp-table tr {
    margin-bottom: 0.75rem;
    border: 1px solid #f0f0f0;
    border-radius: 12px;
    padding: 0.5rem 0.75rem;
  }

  .sp-table tbody td {
    border-bottom: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.5rem 0;
  }

  .sp-table tbody td::before {
    content: attr(data-label);
    font-weight: 700;
    color: #6b7280;
    font-size: 0.82rem;
  }

  .sp-table tbody td[data-label=""]::before {
    display: none;
  }
}
</style>
